const Login = () => import("@/modules/auth/pages/Login.vue");
const Signup = () => import("@/modules/auth/pages/Signup.vue");
const Verify = () => import("@/modules/auth/pages/Verify.vue");
const Confirm = () => import("@/modules/auth/pages/Confirm.vue");
const ResetPassword = () => import("@/modules/auth/pages/ResetPassword.vue");
const Password = () => import("@/modules/auth/pages/Password.vue");

// Please see link below for import .vue caveat
//https://github.com/vuejs/vue-router/issues/713#issuecomment-341100805

export default [
	{
		path: "/",
		component: Login,
		name: "login",
		meta: {
			guest: true,
		},
	},
	{
		path: "/signup",
		component: Signup,
		name: "signup",
		meta: {
			guest: true,
		},
	},
	{
		path: "/verify",
		component: Verify,
		name: "verify",
		meta: {
			guest: true,
		},
	},
	{
		path: "/confirm",
		component: Confirm,
		name: "confirm",
		meta: {
			guest: true,
		},
	},
	{
		path: "/reset-password",
		component: ResetPassword,
		name: "reset-password",
		meta: {
			guest: true,
		},
	},
	{
		path: "/password",
		name: "change-password",
		component: Password,
		beforeEnter: (to, from, next) => {
			const { userId, token } = to.query;
			if (userId && token) {
				next();
			} else {
				next("/");
			}
		},
	},
];
